import { Injectable } from '@angular/core';
import { ModoCameraFacial } from '../../shared/camera-facial.component';
import { CaixaFaceDetectada } from '../../shared/servico-reconhecimento-facial';

export interface EstadoCameraRegistrador {
  cameraAtiva: boolean;
  cameraModo: ModoCameraFacial;
  rostoDetectado: boolean;
  provaVidaOk: boolean;
  capturando: boolean;
  mensagemCamera: string;
  caixaFace?: CaixaFaceDetectada;
  detectorDisponivel: boolean;
  descritorFacialAtual: number[];
  registroAutomaticoDisparado: boolean;
  registroCooldownAte: number;
}

@Injectable({ providedIn: 'root' })
export class ServicoEstadoCameraRegistrador {
  deveAbrirAutomaticamente(
    terminalPublico: boolean,
    terminalAutorizado: boolean,
    empregadorSelecionado: string,
    cameraAtiva: boolean
  ) {
    return terminalPublico && terminalAutorizado && Boolean(empregadorSelecionado) && !cameraAtiva;
  }

  deveFecharPorPerdaDeAutorizacao(
    terminalPublico: boolean,
    terminalAutorizado: boolean,
    cameraAtiva: boolean
  ) {
    return terminalPublico && !terminalAutorizado && cameraAtiva;
  }

  estadoAbertura(modo: ModoCameraFacial): EstadoCameraRegistrador {
    return {
      ...this.estadoBase(modo),
      cameraAtiva: true,
      mensagemCamera: 'Carregando reconhecimento facial.'
    };
  }

  estadoFechado(modoAtual: ModoCameraFacial): EstadoCameraRegistrador {
    return this.estadoBase(modoAtual);
  }

  estadoReinicioContinuo(
    estadoAtual: EstadoCameraRegistrador,
    intervaloMs: number,
    mensagemCamera: string
  ): EstadoCameraRegistrador {
    return {
      ...estadoAtual,
      capturando: false,
      mensagemCamera,
      rostoDetectado: false,
      provaVidaOk: false,
      caixaFace: undefined,
      descritorFacialAtual: [],
      registroAutomaticoDisparado: false,
      registroCooldownAte: Date.now() + intervaloMs
    };
  }

  estaEmCooldown(registroCooldownAte: number) {
    return Date.now() < registroCooldownAte;
  }

  deveDispararRegistroAutomatico(
    rostoDetectado: boolean,
    provaVidaOk: boolean,
    registroAutomaticoDisparado: boolean
  ) {
    return rostoDetectado && provaVidaOk && !registroAutomaticoDisparado;
  }

  mensagemIdentificandoFuncionario() {
    return 'Identificando funcionario e registrando ponto.';
  }

  estadoErroAnalise(estadoAtual: EstadoCameraRegistrador): EstadoCameraRegistrador {
    return {
      ...estadoAtual,
      rostoDetectado: false,
      caixaFace: undefined,
      mensagemCamera: 'Nao foi possivel analisar o rosto.'
    };
  }

  private estadoBase(modo: ModoCameraFacial): EstadoCameraRegistrador {
    return {
      cameraAtiva: false,
      cameraModo: modo,
      rostoDetectado: false,
      provaVidaOk: false,
      capturando: false,
      mensagemCamera: '',
      caixaFace: undefined,
      detectorDisponivel: false,
      descritorFacialAtual: [],
      registroAutomaticoDisparado: false,
      registroCooldownAte: 0
    };
  }
}
